import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedSection, { LatestSection, TopRatedSection } from './components/FeaturedSection';
import CategorySection from './components/CategorySection';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '四虎影院',
  url: 'https://jin-yuan.cn/',
  description: '四虎影院是您的首选在线影视平台，汇聚海量高清电影、电视剧、综艺及动漫资源。',
  inLanguage: 'zh-CN',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://jin-yuan.cn/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '四虎影院',
  url: 'https://jin-yuan.cn/',
  description: '海量高清影片在线观看平台',
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '400-888-6666',
    contactType: 'customer service',
    availableLanguage: ['Chinese'],
  },
};

export default function Home() {
  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <FeaturedSection />
          <CategorySection />
          <LatestSection />
          <TopRatedSection />
        </main>
        <Footer />
      </div>
    </>
  );
}